import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export class BaseFormControlComponent {
  public hasError: boolean;
  public onValueChange: () => void;

  @Input() public controlId: any;

  @Input() public labelName: string;

  @Input() public tooltipName: string;

  @Input() public tooltipPosition: 'left' | 'right' = 'right';

  @Input() public contextualHelpName: string;

  @Input() public set value(value: any) {
    this._value = value;
    if (this.onValueChange) {
      this.onValueChange();
    }
  }

  public get value(): any {
    return this._value;
  }

  @Input() public isFieldDisabled: boolean;
  @Input() public isReadonly: boolean;

  @Output() public readonly valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() public propertyNames: Array<string>;

  private _value: any;
}
